import { useBagStore } from 'src/store';
/**
 * Converts a GetProductDetailsResponse to a Product object for the bag store
 * @param product - The product details response from the API
 * @param quantity - The quantity to add to the bag
 * @returns Product object formatted for the bag store
 * @throws Error if product.offerDetails is missing
 */
export const createBagProduct = (product, quantity) => {
    var _a, _b;
    if (!product.offerDetails) {
        throw new Error('Product offerDetails is required');
    }
    const bagProduct = {
        asin: product.asin,
        offerId: product.offerDetails.offerId || '',
        merchantId: product.offerDetails.merchantId || '',
        selectedOfferId: product.offerDetails.selectedOfferId || '',
        productImageUrl: product.images[0].lowRes || '',
        isPrime: product.prime.isPrime || false,
        quantity,
    };
    if (((_a = product.price) === null || _a === void 0 ? void 0 : _a.currencyCode) && ((_b = product.price) === null || _b === void 0 ? void 0 : _b.amount)) {
        bagProduct.price = {
            currency: product.price.currencyCode,
            amount: product.price.amount,
        };
    }
    return bagProduct;
};
/**
 * Utility function to add a product from GetProductDetailsResponse to the bag
 * @param product - The product details response from the API
 * @param quantity - The quantity to add to the bag
 */
export const addProductDetailsToBag = (product, quantity) => {
    const bagProduct = createBagProduct(product, quantity);
    useBagStore.getState().addToBag(bagProduct);
};
